import { ExternalLink } from "lucide-react";
import { fileUrl } from "@/lib/api";

export function withUtm(url, exhibitionSlug, artworkSlug) {
  try {
    const u = new URL(url);
    u.searchParams.set("utm_source", "banksyguide");
    u.searchParams.set("utm_medium", "artwork");
    u.searchParams.set("utm_campaign", exhibitionSlug);
    u.searchParams.set("utm_content", artworkSlug);
    return u.toString();
  } catch { return url; }
}

export default function ShopBlock({ product, exhibitionSlug, artworkSlug, t, discountActive = true, discount = 25 }) {
  if (!product?.url) return null;
  const href = withUtm(product.url, exhibitionSlug, artworkSlug);
  const img = product.image_url?.startsWith("/api/") ? fileUrl(product.image_url) : product.image_url;
  return (
    <div className="mt-4 flex gap-4 items-center bg-[var(--surface)] border border-[var(--line)] p-3" data-testid="shop-block">
      <div className="w-24 h-24 flex-none overflow-hidden bg-[#222]">
        {img ? <img src={img} alt={product.name || ""} className="w-full h-full object-cover" data-testid="shop-block-image" /> : <div className="art-placeholder w-full h-full">shop</div>}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[0.65rem] tracking-[0.2em] uppercase text-[var(--muted)]" data-testid="shop-block-title">{t("shop_block_title")}</p>
        <p className="text-sm font-semibold mt-1 leading-snug" data-testid="shop-block-product-name">{product.name}</p>
        <a href={href} target="_blank" rel="noreferrer" className="btn-accent inline-flex items-center gap-2 px-3 py-2 text-[0.65rem] mt-2" data-testid="shop-block-button">{t(discountActive ? "shop_block_button" : "shop_block_button_nogift", { discount })} <ExternalLink size={12} /></a>
      </div>
    </div>
  );
}
